export const MASTER_TYPES = {
  PHONE_CONSULTATION: "PHONE_CONSULTATION",
  CONSULTATION: "CONSULTATION",
  NEW: "NEW",
  RETURNING: "RETURNING",
};
